import React from 'react';

import PersonIcon from '@material-ui/icons/Security';

const UserEditIcon = ()=> {
    return (<PersonIcon/>);
}

export default UserEditIcon;